export default __webpack_public_path__ + "static/media/other.14f979c8.png";